import clsx from 'clsx';

import EditableField from '~components/generic/editable-field/EditableField/EditableField';
import DraggableModuleContainer from '~components/generic/module/DraggableModuleContainer';
import { ModulesListPopover } from '~components/generic/module/ModulesListPopover/ModulesListPopover';
import { IEntityComponentProps } from '~interfaces/props';
import { getRelatedEntityIds } from '~services/entity-helpers';
import { getModuleUrlIdFromData } from '~services/location-helpers';
import uniqueId from '~utils/uniqueId';

export const ModuleAccordionItem = ({
  data,
  editing,
  className,
  onChange,
  isActive,
  onActivate,
  stable,
}: IEntityComponentProps) => {
  const classes = clsx({
    ...className,
    'c-accordion__item': true,
    relative: true,
  });
  if (!data) {
    return null;
  }
  const content = data.attributes;
  const slug = uniqueId();
  const childModuleIds = getRelatedEntityIds(data, 'field_modules');
  return (
    <li className={classes} id={getModuleUrlIdFromData(data.id, data.type)}>
      {editing ? (
        <span className="c-accordion__item-title u-nowrap">
          <EditableField
            entityType={data.type}
            fieldName="attributes.field_title.value"
            data={content.field_title.value}
            editing={editing}
            onChange={onChange}
          />
          <i className="c-accordion__item-title-icon u-absolute u-absolute--top u-absolute--right" />
        </span>
      ) : (
        <a
          onClick={onActivate}
          className="c-accordion__item-title"
          aria-controls={`accordion-item-${slug}`}
          aria-expanded={isActive}
        >
          <EditableField
            entityType={data.type}
            fieldName="attributes.field_title.value"
            data={content.field_title.value}
            editing={editing}
            onChange={onChange}
          />
          <i className="c-accordion__item-title-icon u-absolute u-absolute--right" />
        </a>
      )}
      <div
        className="c-accordion__item-content c-module__content"
        aria-hidden={!isActive && !editing}
        id={`accordion-item-${slug}`}
      >
        {editing && childModuleIds.length === 0 && (
          <div className="container relative">
            <ModulesListPopover type={data.type} parentContext={data.id} index={0} />
          </div>
        )}
        {childModuleIds.map((id, i) => (
          <>
            {editing && (
              <div className="container relative">
                <ModulesListPopover type={data.type} parentContext={data.id} index={i} />
              </div>
            )}
            <DraggableModuleContainer
              parentIsStable={stable}
              index={i}
              key={id}
              entityId={id}
              parentContext={data.id}
              parentType={data.type}
              fieldName="relationships.field_modules.data"
              canMove={editing}
            />
          </>
        ))}
      </div>
    </li>
  );
};

export default ModuleAccordionItem;
